import IconChevron from 'components/partials/IconChevron'
import React, { useState } from 'react'

function Accordion({ children, headerChildren, heading, className, ...props }) {
  const [toggled, setToggled] = useState(false)

  const handleClick = () => {
    setToggled(!toggled)
  }

  function AccordionHeader() {
    return (
      <button
        className={`accordion__toggle js-accordion__toggle ${
          className ? `${className}--header` : ''
        }`}
        onClick={handleClick}
        type="submit"
      >
        {headerChildren}
        <IconChevron
          role="presentation"
          aria-hidden="true"
          className="test123"
        />
      </button>
    )
  }
  return (
    <div
      className={`accordion js-accordion rs_preserve ${toggled ? 'is-expanded' : ''} ${
        className || ''
      }`}
      {...props}
      aria-haspopup="true"
      aria-expanded={toggled}
    >
      <AccordionHeader />
      <div
        className={`accordion__content js-accordion__content ${toggled ? 'u-block' : ''} ${
          className ? `${className}--content` : ''
        }`}
      >
        {children}
      </div>
    </div>
  )
}
export default Accordion
